export default __webpack_public_path__ + "static/media/pro_uni_logo_3.9f409268.svg";